import axios from 'axios';
import Vue from 'vue';
import handleErrors from './errorsHandler';

export async function get(endpoint, data) {
    const res = await axios.get(endpoint, {
        params: data,
    });
    return res.data;
}

export async function update(endpoint, data = {}) {
    try {
        const res = await axios.put(endpoint, {
            ...data,
        });

        if (res.status === 200) {
            Vue.toasted.show(res.data.message);
        } else {
            Vue.toasted.global.error();
        }

        return res;
    } catch (error) {
        handleErrors(error);
        return false;
    }
}

export async function store(endpoint, data) {
    try {
        const res = await axios.post(endpoint, {
            ...data,
        });

        if (res.status === 200) {
            Vue.toasted.show(res.data.message);
        } else {
            Vue.toasted.global.error();
        }

        return res;
    } catch (error) {
        handleErrors(error);
        return false;
    }
}

export async function remove(endpoint, items = null, id = null) {
    try {
        const res = await axios.delete(endpoint);

        if (res.status === 200 || res.status === 201) {
            if (items) {
                const foundItem = items.find(item => item.id === id);
                const index = items.indexOf(foundItem);
                if (index !== -1) {
                    Vue.toasted.show(res.data.message);
                    return index;
                }
            } else {
                Vue.toasted.show(res.data.message);
                return true;
            }
        } else {
            Vue.toasted.global.error();
        }

        return res;
    } catch (error) {
        Vue.toasted.global.error();
        return false;
    }
}
